(function () {
  'use strict';

  function initialize() {
    var popup = document.getElementById('yf-show-overlay');
    var video = document.getElementById('yf-show-youtube');
    var closeBtn = document.getElementById('yf-show-close');
    var soundBtn = document.getElementById('yf-sound-button');
    if (!popup || !video || !closeBtn || !popup.showModal) return;

    var mutedVideoUrl = 'https://www.youtube.com/embed/qyR3dWRnQms?autoplay=1&mute=1&rel=0&playsinline=1';
    var soundVideoUrl = 'https://www.youtube.com/embed/qyR3dWRnQms?autoplay=1&mute=0&rel=0&playsinline=1';
    var previousFocus;
    var previousOverflow;
    var timer;
    var today = new Date();
    var todayKey = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');

    function safeGet(storageType, key) {
      try { return window[storageType].getItem(key); } catch (error) { return null; }
    }

    function safeSet(storageType, key, value) {
      try { window[storageType].setItem(key, value); } catch (error) {}
    }

    function isShopping() {
      var active = document.activeElement;
      return document.hidden ||
        (active && active.matches('input, textarea, select, [contenteditable="true"]')) ||
        Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .yf-native-search-dd:not([hidden])')).some(function (element) { return !element.closest('[hidden], [aria-hidden="true"]') && element.getClientRects().length > 0; }) ||
        document.body.classList.contains('yf-equipment-modal-open');
    }

    function showTrailerPopup() {
      if (isShopping()) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      popup.style.display = 'flex';
      popup.showModal();
      document.body.style.overflow = 'hidden';
      video.src = mutedVideoUrl;
      closeBtn.focus({ preventScroll: true });
      safeSet('sessionStorage', 'yfShowOutNowPopupShownThisSession', 'true');
      safeSet('localStorage', 'yfShowOutNowPopupLastShownDate', todayKey);
    }

    function cleanUp() {
      popup.style.display = 'none';
      video.removeAttribute('src');
      document.body.style.overflow = previousOverflow || '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    }

    closeBtn.addEventListener('click', function () { popup.close(); });
    popup.addEventListener('close', cleanUp);
    popup.addEventListener('click', function (event) { if (event.target === popup) popup.close(); });
    if (soundBtn) soundBtn.addEventListener('click', function () {
      video.src = soundVideoUrl;
      soundBtn.textContent = soundBtn.getAttribute('data-sound-on-label');
      soundBtn.setAttribute('aria-pressed', 'true');
    });

    if (popup.getAttribute('data-auto-open') !== 'true' ||
        safeGet('sessionStorage', 'yfShowOutNowPopupShownThisSession') ||
        safeGet('localStorage', 'yfShowOutNowPopupLastShownDate') === todayKey) return;

    function schedule() {
      document.removeEventListener('scroll', schedule);
      timer = window.setTimeout(showTrailerPopup, 2500);
    }
    document.addEventListener('scroll', schedule, { passive: true, once: true });
    window.addEventListener('pagehide', function () { window.clearTimeout(timer); }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
